<template>
    <b-container fluid class="py-3 flex-grow-1 d-flex flex-column">
      <section class="grid-filters">
            <b-row align-h="between" class="mb-3">
                <b-col
                  cols="12"
                        sm="5"
                        md="4"
                        lg="3"
                        xl="4"
                        class="order-0 d-sm-block mb-3 mb-sm-0"
                        :class="{'d-none': !showSearch}"
                >
                    <search-filter
                            :showSearch="showSearch"
                            v-model="query.search"
                    >
                    </search-filter>
                  <div class="mt-4" v-if="gridTitle">
                    <h4>{{ gridTitle }}</h4>
                  </div>
                </b-col>
                <b-col cols="12" sm="7" md="8" lg="9" xl="8">
                    <b-row no-gutters class="justify-content-end">
                        <b-col col sm="auto" class="pr-1">
                            <b-button
                                  :disabled="this.statusFilter!=undefined"
                                  variant="primary"
                                  class="text-center w-100 text-nowrap py-1 px-2"
                                  id="approveButton"
                                  @click="toggle.approved.value = !toggle.approved.value"
                            >
                                <font-awesome-icon
                                        :icon="['far', 'eye' + (!toggle.approved.value ? '-slash' : '')]"
                                        class="mr-1"
                                ></font-awesome-icon>
                                {{ toggle.approved.value ? 'Hide' : 'Show' }} Approved
                            </b-button>
                        </b-col>
                        <b-col col sm="auto" class="pl-1 d-none d-md-block">
                            <b-button
                                    variant="tertiary"
                                    class="text-left w-100 text-nowrap py-1 px-2 filters-toggle"
                                    @click="toggle.filters.value = !toggle.filters.value"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'filter']"
                                    class="mr-1"
                                ></font-awesome-icon>
                                {{ toggle.filters.value ? 'Hide' : 'Show' }} Filters
                </b-button>
                        </b-col>
                        <b-col col sm="auto" class="pl-1 d-none d-md-block">
                          <portal-target v-show="!actionsMenuVisible" name="actions-subnav" />
                        </b-col>
                        <b-col col sm="auto" class="pl-1 d-block d-md-none">
                            <b-button
                                    variant="tertiary"
                                    class="text-center w-100 text-nowrap py-1 px-2"
                                    v-b-modal.quickFiltersModal
                            >
                                <font-awesome-icon
                                        :icon="['fas', 'filter']"
                                        class="mr-1"
                                ></font-awesome-icon>
                                Quick Filters
                            </b-button>
          </b-col>
                    </b-row>
                    <b-row no-gutters class="justify-content-end d-none d-md-block" v-if="toggle.filters.value">
                        <b-col cols="12" class="pt-3 text-right filters-top">

            <multiselect
                    :hide-selected="true"
                    :key="filter.field"
                    :multiple="filter.multiple"
                    :options="filter.options"
                    :placeholder="filter.placeholder"
                    :value="filter.value"
                    class="hide-tags"
                    selectLabel=""
                    v-for="filter in filters"
                    v-model="filter.value"
            >
                                    <template #caret="{ toggle }">
                                        <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
                                    </template>
                                </multiselect>
                        </b-col>
                    </b-row>
                    <b-modal
                            id="quickFiltersModal"
                            static
                            :title="`Quick Filters`"
                            body-class="d-flex flex-column"
                            ok-title="Apply"
                            @ok="applyModalFilters"
                            @show="onModalFilterShow"
                            cancel-variant="outline-secondary"
                    >
                        <b-form-group
                                :label="filter.placeholder"
                                v-for="(filter, key) in filters"
                                :key="filter.field"
                                label-size="sm"
                        >
                            <multiselect
                                    :id="key"
                                    class="small w-100"
                                    v-model="filter.modalValue"
                                    :multiple="filter.multiple"
                                    :options="filter.options"
                                    :placeholder="filter.placeholder | filterPlaceholder"
                                    :hide-selected="filter.multiple"
                                    allowEmpty
                                    selectLabel=""
                            >
                                <template #caret="{ toggle }">
                                    <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
                                </template>
                              </multiselect>
                        </b-form-group>
                    </b-modal>
          </b-col>
        </b-row>
        <portal to="actions-subnav" v-if="showActionsDropdown()"

        >
            <b-dropdown
                no-caret
                right
                variant="outline-primary"
                toggle-class="py-1 px-2"
            >
              <template slot="button-content">
                Actions
                <font-awesome-icon
                  class="ml-1"
                  :icon="['fal', 'chevron-down']"
                  size="xs"
                ></font-awesome-icon>
              </template>
                <b-dropdown-item
                        v-if="$can(
                              $perm.ACTIONS_ADD_CLIENT_ACTIONS,
                              $perm.PERMISSION_TYPE_ACTION,
                            )"
                        @click="addClientAction"
                >
                    <font-awesome-icon
                            :icon="['fal', 'plus']"
                    ></font-awesome-icon>
                    Add Client Action
                </b-dropdown-item>
              <b-dropdown-item
                      @click="openModal('assign')"
                      v-if="$can($perm.ACTIONS_ASSIGN, $perm.PERMISSION_TYPE_ACTION)"
              >
                <font-awesome-icon
                        :icon="['fal', 'users']"
                        size="sm"
                ></font-awesome-icon>
                Assign Selected Actions
              </b-dropdown-item>
              <b-dropdown-item
                      @click="openModal('approve')"
                      v-if="$can(
                      $perm.ACTIONS_BULK_APPROVE_SUBMITTED,
                      $perm.PERMISSION_TYPE_ACTION,
                    )
                      || $can(
                        $perm.ACTIONS_BULK_APPROVE_ADMIN,
                        $perm.PERMISSION_TYPE_ACTION,
                      )"
              >
                <font-awesome-icon
                        :icon="['fal', 'check']"
                        size="sm"
                ></font-awesome-icon>
                Approve Selected Actions
              </b-dropdown-item>
              <b-dropdown-item
                  @click="openModal('note')"
                  v-if="$can($perm.ACTIONS_BULK_ADD_NOTE, $perm.PERMISSION_TYPE_ACTION)"
              >
                <font-awesome-icon
                    :icon="['fal', 'sticky-note']"
                    size="sm"
                ></font-awesome-icon>
                Add Note to Items
              </b-dropdown-item>
              <b-dropdown-item
                      @click="openModal('workOrders')"
                      v-if="$can($perm.ACTIONS_EDIT_WORK_ORDERS, $perm.PERMISSION_TYPE_ACTION)"
              >
                <font-awesome-icon
                    :icon="['fal', 'download']"
                    size="sm"
                ></font-awesome-icon>
                Add Work Order to Items
              </b-dropdown-item>
              <b-dropdown-item
                      @click="openModal('tags')"
                      v-if="$can($perm.ACTIONS_TAG, $perm.PERMISSION_TYPE_ACTION)"
              >
                <font-awesome-icon
                        :icon="['fal', 'tags']"
                        size="sm"
                ></font-awesome-icon>
                Tag Items
              </b-dropdown-item>
              <b-dropdown-item
                      @click="onClickDownloadCsv"
                      v-if="$can($perm.ACTIONS_DOWNLOAD_TO_CSV, $perm.PERMISSION_TYPE_ACTION)"
              >
                <font-awesome-icon
                        :icon="['fal', 'download']"
                        size="sm"
                ></font-awesome-icon>
                Download CSV
              </b-dropdown-item>
                <!--
              <b-dropdown-item
                      @click="onClickDownloadPdf"
                      v-if="showDownloadPdf"
              >
                <font-awesome-icon
                        :icon="['fal', 'file-download']"
                        size="sm"
                ></font-awesome-icon>
                Download PDF
              </b-dropdown-item>
              -->
              <b-dropdown-item
                  @click="onClickDownloadAll"
                  v-if="$can($perm.ACTIONS_DOWNLOAD_ALL_ACTIONS, $perm.PERMISSION_TYPE_ACTION)"
              >
                <font-awesome-icon
                    :icon="['fal', 'download']"
                    size="sm"
                ></font-awesome-icon>
                Download All
              </b-dropdown-item>
            </b-dropdown>
          </portal>
      </section>

        <b-row class="flex-grow-1 d-flex flex-column">
            <b-col class="flex-grow-1 d-flex flex-column">
                <b-row class="grid-count mb-3 justify-content-between align-items-baseline">
                    <b-col cols="8" class="d-flex align-items-baseline text-dark">
                        <span>
                          {{ count }} Results
                          <span class="font-weight-bold"
                                v-if="selectedCount > 0"
                          >
                            | {{ selectedCount }} selected
                          </span>
                        </span>
                    </b-col>
                    <b-col cols="4" class="d-flex justify-content-end">
                        <reset-filters
                                @click="resetGridFilters"></reset-filters>
                        <refresh-button
                                :spinning="refreshing"
                                @click="refresh"
                        ></refresh-button>
                    </b-col>
                </b-row>
                <div v-if="allFilters.length > 0" class="filters-all mb-2">
                    <div class="filters-all-items">
                        <b-badge :key="filter.label"
                                 @click="removeFilter(filter)"
                                 pill
                                 v-for="filter in allFilters"
                                 variant="secondary"
                                 class="mb-2"
                        >
                          {{ filter.label }}
                          <font-awesome-icon
                                  :icon="['fal', 'times-circle']"
                          ></font-awesome-icon>
                        </b-badge>
                        <span
                                @click="resetFilters"
                                class="filters-reset small"
                        >Reset all</span>
                    </div>
                </div>
            <div class="grid-wrapper flex-grow-1 d-flex">
            <ag-grid-vue
                    class="ag-theme-balham"

                    :cacheQuickFilter="cacheQuickFilter"
                    @cellClicked="openActionModal"

                    :columnDefs="columnDefs"
                    @columnMoved="saveGridOptions"
                    @columnPinned="saveGridOptions"
                    @columnResized="saveGridOptions"
                    :columnTypes="columnTypes"
                    @columnVisible="saveGridOptions"
                    :defaultColDef="defaultColDef"

                    :doesExternalFilterPass="doesExternalFilterPass"

                    @filterChanged="saveGridOptions"
                    :floatingFilter="floatingFilter"
                    :gridOptions="gridOptions"
                    @grid-ready="onGridReady"

                    :headerHeight="rowHeight"
                    :isExternalFilterPresent="isExternalFilterActive"
                    :quickFilter="query.search"
                    :rowData="rowData"

                    :rowHeight="rowHeight"
                    @rowSelected="updateRowSelected"

                    :rowSelection="rowSelection"
                    :side-bar="sideBarDef"

                    @sortChanged="saveGridOptions"

                    :style="'width: ' + gridWidth +'%; height: 100%;'"
                    :suppressExcelExport="suppressExcelExport"
            ></ag-grid-vue>
          </div>
        </b-col>
      </b-row>
      <add-client-action-modal
            v-if="modals.add.visible"
            :show.sync="modals.add.visible"
            :enablePropertySelect="true"
            @refresh-all="refresh"
      ></add-client-action-modal>
      <work-order-modal
          v-if="modals.workOrders.visible"
          :node-ids="selected.nodeIds"
          :action-count="count"
          :show.sync="modals.workOrders.visible"
          @refresh-all="refresh"
          :type="'client'"
      ></work-order-modal>
      <tag-modal
              :action-count="count"
              :node-ids="selected.nodeIds"
              :show.sync="modals.tags.visible"
              @refresh-all="refresh"
              @tag-all="selectAll"
              v-if="modals.tags.visible"
      ></tag-modal>
      <client-action-assign-modal
              :options="assignOptions"
              :action-count="count"
              :node-ids="selected.nodeIds"
              :show.sync="modals.assign.visible"
              @assign-all="selectAll"
              @refresh-all="refresh"
              v-if="modals.assign.visible"
      ></client-action-assign-modal>
      <approve-modal
              :invalid-status="invalidStatus"
              :invalidNodes="invalidNodes"
              :node-ids="selected.nodeIds"
              :nodes="validNodes"
              :show.sync="modals.approve.visible"
              @refresh-all="refresh"
              v-if="modals.approve.visible"
              type="client"
      ></approve-modal>
      <note-modal
          :title="modals.note.settings.noteTitle"
          :show.sync="modals.note.visible"
          :client-action-ids="selected.nodeIds"
          :busy="modals.note.loading"
          :sentNoteFn="modals.note.settings.sentNoteFn"
          @file-sent="modals.note.settings.onSentFileFn"
          :file-url="modals.note.settings.fileUrl"
          :note-placeholder="modals.note.settings.notePlaceholder"
          :button-text="modals.note.settings.noteButtonText"
          :error-message="modals.note.settings.noteErrorMessage"
      ></note-modal>
      <router-view name="clientActionPage"></router-view>
    </b-container>
</template>


<script lang="js">
import { AgGridVue } from 'ag-grid-vue';
import dayjs from 'dayjs';
import { filter as objFilter, forEach, size } from 'lodash';
import { mapGetters } from 'vuex';
import {
  clientActionGridColumnTypes,
  clientActionGridDefaultColDef,
  queryGridColumns,
  getClientActionGridColumns,
} from '@/services/Action/ClientActionGridConfig';
import CaretIcon from '@/components/Form/CaretIcon';
import ClientAction from '@/services/Action/ClientAction';
import ClientActionFilter from '@/services/Action/ClientActionFilter';
import debounce from 'lodash/debounce';
import TagModal from '@/components/Action/Modal/TagModal';
import ClientActionAssignModal from '@/components/Action/Modal/ClientActionAssignModal';
import ApproveModal from '@/components/Action/Modal/ApproveModal';
import ClientActionModal from '@/components/Action/Modal/ClientActionModal';
import NoteModal from '@/components/Action/Modal/NoteModal';
import ActionStatus from '@/services/Action/ActionStatus';
import GridMixin from '@/components/Grid/GridMixin';
import api from '@/api';
import ResetFilters from '@/components/Grid/ResetFilters';
import RefreshButton from '@/components/Grid/RefreshButton';
import SearchFilter from '@/components/Grid/SearchFilter';
import ActionType from '@/services/Action/ActionType';
import ClientActionAssign from '@/services/Action/ClientActionAssign';
import AddClientActionModal from '@/components/Action/Modal/AddClientActionModal';
import riskhub from "@/services/Riskhub/Riskhub";
import Action from "@/services/Action/Action";
import WorkOrderModal from "@/components/Action/Modal/BulkEditWorkOrderModal.vue";

const FILTER_SET = 'SET';
const FILTER_TEXT = 'TEXT';

export default {
  name: 'Client-Actions',
  components: {
    WorkOrderModal,
    AgGridVue,
    CaretIcon,
    TagModal,
    ClientActionAssignModal,
    ApproveModal,
    ClientActionModal,
    NoteModal,
    ResetFilters,
    RefreshButton,
    SearchFilter,
    AddClientActionModal,
  },
  mixins: [GridMixin],
  data() {
    return {
      // This is for the API cancel request
      modelId: 'clientActionId',
      loading: false,
      actionType: ActionType.getTypeName(ActionType.CLIENT()),
      cancelSource: null,
      ignoreWatches: false,
      assignOptions: [],
      filters: {
        team: {
          type: FILTER_SET,
          placeholder: 'Filter Team',
          field: 'currentResponsibleTeam',
          multiple: true,
          options: [],
          value: [],
          modalValue: [],
          fill: true,
        },
        user: {
          type: FILTER_SET,
          placeholder: 'Filter User',
          field: 'reviewer',
          multiple: true,
          options: [],
          value: [],
          modalValue: [],
          fill: true,
        },
        overdue: {
          placeholder: 'Filter Due Dates',
          multiple: false,
          external: true,
          filterFunction: node => this.filterOverdue(node),
          options: [
            ClientActionFilter.FILTER_DATE_OVERDUE(),
            ClientActionFilter.FILTER_DATE_WITHIN(),
          ],
          value: [],
          modalValue: [],
        },
        tag: {
          type: FILTER_SET,
          placeholder: 'Filter Tag',
          field: 'tags',
          multiple: true,
          options: [],
          value: [],
          modalValue: [],
          fill: false,
        },
      },
      toggle: {
        approved: {
          value: false,
        },
        filters: {
          value: true,
        },
      },
      defaultColDef: clientActionGridDefaultColDef,
      columnTypes: clientActionGridColumnTypes,
      columnDefs: null,
      validNodes: [],
      invalidNodes: [],
      invalidStatus: '',
      modals: {
        note: {
          visible: false,
          loading: false,
          settings: {
            noteTitle: 'Add a note',
            noteButtonText: 'Send note',
            sentNoteFn: null,
            notePlaceholder: null,
            noteErrorMessage: null,
            onSentFileFn: () => null,
            showNoteModal: null,
            fileUrl: null,
          },
        },
        action: {
          visible: false,
        },
        tags: {
          visible: false,
        },
        workOrders: {
          visible: false,
        },
        assign: {
          visible: false,
        },
        approve: {
          visible: false,
        },
        add: {
          visible: false,
        },
      },
    };
  },

  computed: {

  ...mapGetters({
      showSearch: 'actionShowSearch',
      // actionRefresh: 'actionRefresh',
      // statusFilter: 'actionStatusFilter',
      optionTags: 'optionTags',
      actionsMenuVisible: 'actionsMenuVisible',
    }),
    actionRefresh() {
      return this.$store.getters.actionRefresh;
    },
    statusFilter() {
      return this.$store.getters.actionStatusFilter;
    },
    gridTitle() {
      return ActionStatus.getTitle(this.statusFilter)
    },
    /**
     * This combines all the filters that are applied via external dropdowns
     * It is used mainly for visual purposes
     * * */
    allFilters() {
      const allFilters = [];

      Object.entries(this.filters)
        .forEach(([type, item]) => {
          // If it's not an array, we push just the string with no index
          if (!Array.isArray(item.value)) {
            allFilters.push({
              type,
              index: 0,
              label: item.value,
            });
            return;
          }

          Object.values(item.value)
            .forEach((label, index) => {
              allFilters.push({
                type,
                index,
                label,
              });
            });
        });

      return allFilters;
    },

    optionTags() {
      return this.$store.getters.optionTags;
    },

    showDownloadPdf() {
      return !!(this.$can(this.$perm.ACTIONS_DOWNLOAD_TO_PDF, this.$perm.PERMISSION_TYPE_ACTION)
        && !this.statusFilter);
    },
  },

  watch: {
    // We check the route to see if the status has changed via the status filter parameter
    // We set the state status filter, which triggers the table to refresh
    // We do not want to set this if the route is loading an individual action
    $route: {
      handler(route) {
        if (route.params.clientActionId) {
          return;
        }

        const { statusFilter } = route.params;
        this.$store.dispatch('setActionsFilter', { status: ActionStatus.getStatusByRoute(statusFilter) });
      },
      immediate: true,
    },

    async statusFilter() {
      // Wait for any extra components to render first before refreshing
      this.resetFilters();
      await this.setGridColumns();
      this.refresh();
    },

    actionRefresh(refresh) {
      if (refresh) {
        this.refresh();
      }
    },

    '$store.getters.propertyTenure': function (value) {
      this.refresh();
    },

    'filters.team.value': function () {
      this.onFilterChange(this.filters.team);
    },
    'filters.user.value': function () {
      this.onFilterChange(this.filters.user);
    },
    'filters.tag.value': function () {
      this.onFilterChange(this.filters.tag);
    },
    'filters.overdue.value': function () {
      this.gridApi.onFilterChanged();
    },
    'toggle.approved.value': function () {
      this.refresh();
    },
    'toggle.responseStatusOnly.value': function toggleResponseStatusOnlyValue() {
      this.gridApi.onFilterChanged();
    },
    'toggle.filters.value': function toggleShowFiltersValue() {
      // this.gridApi.onFilterChanged();
    },
  },

  filters: {
    filterPlaceholder(placeholder) {
      return `Select ${placeholder.replace(/Filter/, '')}`;
    },
  },

  created() {
    this.columnDefs = getClientActionGridColumns().filter(this.filterColumn);
  },

  mounted() {
    this.onMountQueryParams();
    this.$store.dispatch('refreshTags')
      .then(() => {
        this.refreshTagFilter();
      });
    this.setAssignOptions();
  },

  methods: {
    postGridReady(params) {
      this.setRowClasses();

      this.refresh();
    },
    /**
     * Resets grid to absolute default
     */
    preResetGridFilters() {
      this.resetting = true;
      forEach(this.filters, (filter, type) => {
        this.filters[type].value = [];
      });

        if (Object.entries(this.$router.currentRoute.query).length) {
          this.$router.replace({ query: null }).catch(err => {});
        }
    },

    postResetGridFilters() {
      this.$nextTick(() => {
        this.resetting = false;
      });
    },

    /**
     * Set the grid columns based on permissions / status
     **/
    setGridColumns() {
      return new Promise((resolve) => {
        let columnDefs = getClientActionGridColumns().filter(this.filterColumn);

        // We have some specific columns to add if we're on the query status page
        if (this.statusFilter === ActionStatus.QUERY()) {
          columnDefs = [...columnDefs, ...queryGridColumns];
        }

        this.columnDefs = columnDefs;

        this.$nextTick(() => {
          resolve();
        });
      });
    },

    /**
     * Filter columns based on permissions
     *
     * @param {Object} column
     */
    filterColumn(column) {
      if (column.field === 'dueDate') {
        return this.$can(
          this.$perm.ACTIONS_VIEW_ACTION_DUE_DATE,
          this.$perm.PERMISSION_TYPE_ACTION,
        );
      }
      if (column.field === 'workOrder') {
        return this.$can(
          this.$perm.ACTIONS_VIEW_WORK_ORDERS,
          this.$perm.PERMISSION_TYPE_ACTION,
        );
      }
      return true;
    },

    /**
     * Sets the grid up with:
     * Column state
     * Sort
     * Filters
     */
    setGridOptions() {
      const name = 'client-' + (this.statusFilter || 'actions');

      let gridState = this.$store.getters.gridState(name);
      let gridSort = this.$store.getters.gridSort(name);
      let gridFilter = this.$store.getters.gridFilter(name);

      if (!gridState) {
        gridState = this.gridDefaults.state;
      }

      if (!gridSort) {
        gridSort = this.gridDefaults.sort;
      }

      if (!gridFilter) {
        gridFilter = this.gridDefaults.filter;
      }

      this.columnApi.setColumnState(gridState);

      if (this.hasQueryString()) {
        return;
      }

      this.gridApi.setSortModel(gridSort);
      this.gridApi.setFilterModel(gridFilter);
      this.gridApi.onFilterChanged();
      this.setTopFilterValues(gridFilter);
    },

    // Sets the filters at the top, which displays a visual representation
    // If grid options are saved, they can be reloaded in and set so the top level filters match too
    // Since all they do is trigger AG Grid's filters anyway
    setTopFilterValues(gridFilters) {
      forEach(gridFilters, (options, filterName) => {
        const matchFilter = objFilter(this.filters, f => f.field === filterName);

        if (matchFilter[0]) {
          matchFilter[0].value = options.values;
        }
      });
    },

    /**
     * Only allow to save the grid if it is not refreshing data
     * */
    saveGridOptions() {
      if (this.refreshing) {
        return false;
      }

      if (this.hasQueryString()) {
        return false;
      }

      return this.saveOptions();
    },

    /**
     * Save the grid options (only allowed once per second)
     */
    saveOptions: debounce(function () {
      const state = this.columnApi.getColumnState();
      const sort = this.gridApi.getSortModel();
      const filter = this.gridApi.getFilterModel();

      const name = 'client-' + (this.statusFilter || 'actions');

      this.$store.dispatch('saveGridOptions', {
        name,
        state,
        sort,
        filter,
      });
    }, 1000),

    /**
     * Checks if an external filter is actually active
     */
    isExternalFilterActive() {
      // If overdue is active, as it is the only filter based on conditions
      let active = false;
      Object.entries(this.filters)
        .forEach(([type, item]) => {
          if (!item.external) {
            return;
          }

          if (item.value && item.value.length > 0) {
            active = true;
          }
        });

      return active;
    },

    /**
     * Checks to see if all external filters pass (like being overdue)
     */
    doesExternalFilterPass(node) {
      let success = false;
      const filterPass = [];
      Object.entries(this.filters)
        .forEach(([type, item]) => {
          if (!item.external) {
            return;
          }

          if (item.filterFunction) {
            filterPass.push(item.filterFunction(node));
          }
        });

      filterPass.forEach((boolean) => {
        success = boolean;
      });

      // Incase it is undefined
      if (!success) {
        success = false;
      }

      return success;
    },

    /**
     * Checks each row of data if they are overdue
     * This is based on the dueDate
     */
    filterOverdue(node) {
      const overdueFilter = this.filters.overdue.value;
      const now = dayjs();
      const dueDate = dayjs(node.data.dueDate);

      if (overdueFilter === ClientActionFilter.FILTER_DATE_OVERDUE()) {
        return dueDate.isBefore(now);
      }

      if (overdueFilter === ClientActionFilter.FILTER_DATE_WITHIN()) {
        if (!node.data.dueDate) {
          return true;
        }

        return dueDate.isAfter(now);
      }

      return false;
    },

    preRefresh() {
      return !!this.gridApi;
    },

    /**
     * Async
     * Refreshes the table
     * Sets the grid options afterwards
     */
    async refresh() {
      if (!this.preRefresh()) {
        return;
      }

      // Cancel any previous requests
      if (this.cancelSource) {
        this.cancelSource.cancel();
      }

      this.$store.dispatch('refreshClientActionCounts');
      // Wait until the data is set, external dropdown filters are set
      await this.refreshData();
      // Then we set the grid options
      this.setGridOptions();
      // We set a timeout to disallow any future grid saving that happens
      // As filters are applied immediately after;
      this.postRefresh();
    },

    /**
     * Call after every refresh
     * */
    postRefresh() {
      this.postRefreshQueryParams();
      this.setDropdownFilters();
      this.updateRowSelected();
      this.gridApi.hideOverlay();
      this.refreshTagFilter();
      this.$store.dispatch('refreshActionsComplete');

      setTimeout(() => {
        this.refreshing = false;
      }, 0);
    },

    /**
     * Sets the rowdata with data from the server
     */
    refreshData() {
      this.refreshing = true;

      const params = this.getParams();

      this.cancelSource = api.CancelToken.source();

      let rowData = [];
      return ClientAction.list(params, this.cancelSource)
        .then((response) => {
          rowData = response.data.data;
        })
        .catch((error) => {
          if (!api.isCancel(error)) {
            this.$notify({
              duration: 5000,
              title: 'Error',
              text: 'We couldn\'t obtain the client actions right now. Please try again later.',
              type: 'error',
            });
          }
        })
        .finally(() => {
          this.rowData = rowData;
        });
    },

    /**
     * Set row classes
     */
    setRowClasses() {
      const now = dayjs();

      this.gridOptions.getRowClass = ({ data }) => {
        if (!data) {
          return '';
        }

        if (data.status !== ActionStatus.APPROVED()) {
          if (now.isAfter(dayjs(data.dueDate))) {
            return 'orange-row';
          }
        }
        return '';
      };
    },

    /**
     * Check if the current route has a query string present
     */
    hasQueryString() {
      const { query } = this.$route;

      return (query && size(query) > 0);
    },

    /**
     * Anything to do with query params that should happen on mount
     */
    onMountQueryParams() {
      if (!this.hasQueryString()) {
        return;
      }

      const { query } = this.$route;

      forEach(query, (value, field) => {
        if (Array.isArray(value)) {
          value = value[0];
        }

        if (field === 'status'
          && value === ActionStatus.APPROVED()
        ) {
          this.toggle.approved.value = true;
        }
      });
    },

    /**
     * Apply any parameters from the query string to the grid
     */
    postRefreshQueryParams() {
      const { query } = this.$route;

      if (this.hasQueryString()) {
        forEach(query, (value, field) => {
          if (field === 'overdue') {
            const filters = {
              1: ClientActionFilter.FILTER_DATE_OVERDUE(),
              2: ClientActionFilter.FILTER_DATE_WITHIN(),
            };

            this.filters.overdue.value = filters[value];

            return;
          }

          this.onFilterChange({
            field,
            value,
            type: FILTER_SET,
          });
        });
      }
    },

    /**
     * Gets any params for fetching data from the server
     */
    getParams() {
      const params = {};

      params['filter[status]'] = this.statusFilter ||
          (!!this.toggle.approved.value ? 'all' : 'open')

      params.propertyTenure = this.$store.getters.propertyTenure;

      return {
        params,
      };
    },

    /**
     * Set all filters for external dropdowns
     */
    setDropdownFilters() {
      // Duplicate filter object
      const filters = Object.entries(this.filters)
        .filter(([type, item]) =>
          !item.external
          && item.type === FILTER_SET
          && item.fill
        );
      // Add a set
      filters.forEach(([type, item]) => {
        item.set = new Set();
      });

      // Loop through each row of data
      // Add field to a unique set
      this.rowData.forEach((node) => {
        filters.forEach(([type, item]) => {
          const field = node[item.field];
          if (field !== undefined && field !== null) {
            item.set.add(field);
          }
        });
      });

      // Assign the set to the original filters as options
      filters.forEach(([type, item]) => {
        this.filters[type].options = [...item.set].sort();
      });
    },

    /**
     *  Reset all filters
     */
    resetFilters() {
      this.resetting = true;

      Object.entries(this.filters)
        .forEach(([type, item]) => {
          this.filters[type].value = [];
        });

      this.$nextTick(() => {
        this.resetting = false;
      });

      this.gridApi.setQuickFilter(null);
      this.query.search = '';
      this.gridApi.setFilterModel(this.gridDefaults.filter);
    },

    /**
     * Remove filter by type + index
     * @param type
     * @param index
     */
    removeFilter({ type, index }) {
      if (!Array.isArray(this.filters[type].value)) {
        this.filters[type].value = [];
      } else {
        this.filters[type].value.splice(index, 1);
      }

      if (this.filters[type].type === FILTER_SET) {
        this.filterSet(this.filters[type]);
      } else if (this.filters[type].type === FILTER_TEXT) {
        this.filterText(this.filters[type]);
      }

      this.gridApi.onFilterChanged();
    },

    applyModalFilters() {
      Object.entries(this.filters)
        .forEach(([type, item]) => {
          this.filters[type].value = this.filters[type].modalValue;
        });

      this.applyFilters();
    },

    applyFilters() {
      Object.entries(this.filters)
        .forEach(([type, item]) => {
          if (item.type === FILTER_SET) {
            this.filterSet(item);
          } else if (item.type === FILTER_TEXT) {
            this.filterText(item);
          }
        });

      this.gridApi.onFilterChanged();
    },

    onModalFilterShow() {
      Object.entries(this.filters)
        .forEach(([type, item]) => {
          this.filters[type].modalValue = this.filters[type].value;
        });
    },

      refreshTagFilter() {
        this.filters.tag.options = this.optionTags;
    },

    validateApprove() {
      this.validNodes = [];
      this.invalidNodes = [];

      const adminBulk = this.$can(
        this.$perm.ACTIONS_BULK_APPROVE_ADMIN,
        this.$perm.PERMISSION_TYPE_ACTION,
      );

      this.invalidStatus = ActionStatus.PENDING_APPROVAL();

      if (adminBulk) {
        this.invalidStatus = ActionStatus.APPROVED();
      }

      this.getSelectedNodes()
        .forEach((node) => {
          if (node.data.status !== ActionStatus.PENDING_APPROVAL()
            && !adminBulk
          ) {
            this.invalidNodes.push(node);
            return true;
          }

          if (adminBulk && node.data.status === ActionStatus.APPROVED()) {
            this.invalidNodes.push(node);
            return true;
          }

          this.validNodes.push(node);
        });

      if (this.validNodes.length === 0) {
        this.$notify({
          title: 'No valid actions selected',
          text: 'Please select client actions that have the status of \'Pending Approval\'',
          type: 'error',
        });

        return false;
      }

      this.invalidNodes.forEach(node => node.setSelected(false));

      return true;
    },

    openActionModal(node) {
      // Don't open modal if you mis click on a checkbox cell
      if (node.column.colDef.checkboxSelection) {
        return;
      }

      const clientActionId = (node.data) ? node.data.clientActionId : 0;

      if (!clientActionId) {
        return;
      }

      this.$router.push({
        name: 'clientActionPage',
        params: { clientActionId }
      });
      // this.modals.action.visible = true;
    },

    addClientAction() {
      this.modals.add.visible = true;
      return true;
    },

    /**
     * Opens a modal by name (in data -> modals.[name])
     */
    openModal(name) {
      if (this.refreshing) {
        this.$notify({
          title: 'Please wait..',
          text: 'Actions are currently being loaded, please try again',
          type: 'warn',
        });

        return false;
      }

      if (this.selectedIds.length === 0) {
        this.$notify({
          title: 'No actions selected',
          text: 'Please select at least one action.',
          type: 'warn',
        });

        return false;
      }

      if (name === 'approve' && !this.validateApprove()) {
        return false;
      }

      if (name === 'note') {
        this.setNoteDefaults();
        this.modals.note.settings.sentNoteFn = this.addNote;
        this.modals.note.settings.notePlaceholder = 'Write a note...';
        this.modals.note.settings.noteErrorMessage = 'Please enter a note';
        this.modals.note.settings.fileUrl = `${api.defaults.baseURL}/actions/client/note`;
        this.modals.note.settings.onSentFileFn = this.onSuccessfulNote;
        this.modals.note.settings.showNoteModal = true;
      }

      this.modals[name].visible = true;
      return true;
    },

    /**
     * Add a note against an action
     */
    async addNote({ note }) {
      try {
        await ClientAction.bulkAddNote(
            this.getSelectedNodes().map(node => node.data[this.modelId]),
            note,
        );

        this.onSuccessfulNote();
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.modals.note.loading = false;
      }
    },

    setNoteDefaults() {
      this.modals.note.settings.noteTitle = 'Add a note';
      this.modals.note.settings.noteButtonText = 'Send note';
      this.modals.note.settings.notePlaceholder = null;
      this.modals.note.settings.noteErrorMessage = null;
      this.modals.note.settings.fileUrl = null;
    },

    onSuccessfulNote() {
      const title = 'Note successfully added';
      const text = '';
      const type = 'success';

      this.$notify({
        duration: 7000,
        title,
        text,
        type,
      });

      this.modals.note.visible = false;
    },

    setAssignOptions() {
      if (this.$can(this.$perm.ACTIONS_ASSIGN, this.$perm.PERMISSION_TYPE_ACTION)) {
        this.loading = true;
        ClientActionAssign.getFormattedOptions().then((options) => {
          this.assignOptions = options;
          this.loading = false;
        });
      }
    },

    /**
     * @returns {boolean}
     */
    onClickDownloadPdf() {
      let reviewer = '';

      const teams = this.filters.team.value;
      const users = this.filters.user.value;

      if (teams.length > 0) {
        reviewer = teams.join(', ');
      }

      if (users.length > 0) {
        reviewer += users.join(', ');
      }

      if (reviewer === '') {
        this.$notify({
          title: 'No user or teams selected',
          text: 'Please select at least one user or team to filter by',
          type: 'warn',
        });
        return false;
      }

      const clientActionIds = [];

      this.gridApi.forEachNodeAfterFilter((node) => {
        if (node.data) {
          clientActionIds.push(node.data.clientActionId);
        }
      });

      const params = {
        clientActionIds,
        reviewer,
      };

      this.$notify({
        title: 'PDF processing...',
        text: 'Please wait while the PDF is being created',
        type: 'warn',
        duration: 6000,
      });

      ClientAction.downloadPdf(params);
      return true;
    },

    onClickDownloadCsv() {
      const processCellCallback = (params) => {
        const column = params.column.getColId();
        let { value } = params;

        switch (column) {
          case 'query':
            value = value.replace(/<br \/>/g, '');
            value = value.replace(/\n/g, '');
            value = value.replace(/\r/g, ' ');
            break;

            /*
          case 'photosBtn':
            value = (value) ? 'Y' : 'N';
            break;
            */

          case 'numberRange':
          case 'streetNumber':
            if (value) {
              value = `="${value}"`;
            }
            break;

          case 'dueDate':
          case 'createdDate':
          case 'completedDate':
            value = riskhub.formatDate(value, true) || 'N/A';
            break;
          case 'tenure':
          case 'notes':
            if (value) {
              // Remove all kinds of line breaks
              value = value.replace(/(\r\n|\n|\r)/gm, '');
            }
            break;
        }

        return value;
      };

      const onlySelected = this.getSelectedNodes().length > 0;
      const params = {
        processCellCallback,
        onlySelected,
      };

      this.gridApi.exportDataAsCsv(params);
    },
    async onClickDownloadAll() {
      await ClientAction.downloadAll(this.$store.getters.complianceTypeId);
      this.$notify({
        title: 'Creating download',
        text: 'A download of your actions is being created and will be emailed to you shortly',
        type: 'success',
        duration: 6000,
      });
    },
    showActionsDropdown() {
        return this.$can(this.$perm.ACTIONS_ADD_CLIENT_ACTIONS, this.$perm.PERMISSION_TYPE_ACTION)
            ||  this.$can(this.$perm.ACTIONS_ASSIGN, this.$perm.PERMISSION_TYPE_ACTION)
            ||  this.$can(this.$perm.ACTIONS_BULK_APPROVE_SUBMITTED, this.$perm.PERMISSION_TYPE_ACTION)
            ||  this.$can(this.$perm.ACTIONS_BULK_APPROVE_ADMIN, this.$perm.PERMISSION_TYPE_ACTION)
            ||  this.$can(this.$perm.ACTIONS_TAG, this.$perm.PERMISSION_TYPE_ACTION)
            ||  this.$can(this.$perm.ACTIONS_DOWNLOAD_TO_CSV, this.$perm.PERMISSION_TYPE_ACTION)
            ||  this.$can(this.$perm.ACTIONS_DOWNLOAD_ALL_ACTIONS, this.$perm.PERMISSION_TYPE_ACTION);
    },
  },
};
</script>

<style lang="scss" scoped>
    .filters-toggle {
        min-width: 130px;
    }
    .filters-top {
    display: flex;
    font-size: 14px;
    justify-content: flex-end;

    > div {
            margin-left: 15px;
    }

    .multiselect {
            max-width: 220px;
            min-width: 150px;
            min-height: 36px;

            /deep/ &__input {
                font-size: 15px;
        border-color: $border-color;
      }

            /deep/ &__placeholder {
        display: none;
      }

            /deep/ &__caret {
                top: 5.5px !important;
            }
      }
        /deep/ .multiselect__tags {
            border-color: $border-color;
            padding-top: 0.2rem !important;
            padding-bottom: 0.2rem !important;
            padding-left: 0.2rem !important;
            min-height: 14px;
        }
    }
      .filters-all {
        .filters-reset {
          color: #848484;
          cursor: pointer;
          text-decoration: underline;
        }

        .badge {
          margin-right: 0.75rem;
      font-size: 14px;
      padding: 5px 10px;
      font-weight: $font-weight-base;
      cursor: pointer;

      .fa-times-circle {
        margin-left: 5px;
      }
    }
  }
    @media screen and (max-width: 992px) {
        .filters-top {
            > div {
                margin-left: 5px;
            }

            .multiselect {
                /deep/ &__input {
                    font-size: 12px;
                }
            }

            /deep/ .multiselect__tags {
                padding-left: 0.2rem !important;
            }

            .ag-wide {
                min-width: 300px;
            }
        }
  }
</style>
